'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('apis', {
      url: '/apis',
      template: '<apis></apis>'
    });
}



// WEBPACK FOOTER //
// ./client/app/apis/apis.routes.js